// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ArrowDown from "@ces/XDL/Icons/ArrowDown";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { xBaseTheme } from "@ces/XDL/types";
import { color } from "@ces/XDL/Utilities";
import DynamicDropdownPresentationPropsDefault from "@insite/mobius/DynamicDropdown/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DynamicDropdownPresentationPropsDefault,
        cssOverrides: {
            list: css`
                width: 100%;
                border-radius: 0 0 2px 2px;
                margin-top: -3px;
                box-shadow: none;
                border-color: ${color("primary")};
            `,
            dropdownWrapper: css`
                && input[aria-expanded="true"]:not([data-test-selector*="disable_icon_rotation"]) ~ ${IconWrapper} {
                    transform: rotate(180deg);
                    padding-left: 14px;
                }
            `,
            option: css`
                font-size: 16px;
                font-weight: ${fontConfig.weight.regular};
                letter-spacing: 0;
                line-height: 26px;
                color: ${color("text")};
                background: ${color("common.white")};
                padding: 10px;
                &:hover {
                    background: ${color("common.ui2")};
                }
                &[disabled],
                &[disabled] ~ ${IconWrapper} {
                    opacity: 0.33;
                }
                &[aria-selected="true"] {
                    color: ${color("common.white")};
                    background: ${color("common.ui7")};
                }
            `,
        },
        iconProps: {
            color: "text.link",
            src: ArrowDown,
            size: 13,
            css: css`
                &&& {
                    display: flex;
                    justify-content: flex-end;
                    padding-right: 14px;
                    width: auto;
                }
                svg {
                    width: 8px;
                    height: 13px;
                }
            `,
        },
    },
} as xBaseTheme["dynamicDropdown"];
